import { Resource, Resources } from 'constants/resources';

import AccountBox from '@mui/icons-material/AccountBox';
import CreditCard from '@mui/icons-material/CreditCard';
import Dashboard from '@mui/icons-material/Dashboard';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import ForkRight from '@mui/icons-material/ForkRight';
import ImportContacts from '@mui/icons-material/ImportContacts';
import MonetizationOn from '@mui/icons-material/MonetizationOn';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import Person from '@mui/icons-material/Person';
import Power from '@mui/icons-material/Power';
import Rule from '@mui/icons-material/Rule';
import Security from '@mui/icons-material/Security';
import ShoppingCart from '@mui/icons-material/ShoppingCart';
import { MenuItem } from '@mui/material';
import { TranslationKey } from 'providers/i18n/types';

export type MultiLevelMenuItem = {
  icon: React.ReactElement;
  title: TranslationKey;
  items: MenuItem[];
};

export type MenuItem = {
  resource: Resource;
  //TODO: Пункты меню не всегда нужно переводить!
  title: TranslationKey;
  icon?: React.ReactElement;
  counter?: string;
};

export type MenuList = (MenuItem | MultiLevelMenuItem)[];

const FINANCE: MultiLevelMenuItem = {
  title: 'app.navMenu.finance.title',
  icon: <MonetizationOn />,
  items: [
    {
      resource: Resources.BalanceReport,
      title: 'app.navMenu.finance.balanceReport',
    },
    {
      resource: Resources.CumulativeReport,
      title: 'app.navMenu.finance.cumulativeReport',
    },
    {
      resource: Resources.OrdersReport,
      title: 'app.navMenu.finance.ordersReport',
    },
    {
      resource: Resources.RefundChargebackReport,
      title: 'app.navMenu.finance.refundChargebackReport',
    },
    {
      resource: Resources.ExpenseReport,
      title: 'app.navMenu.finance.expenseReport',
    },
    {
      resource: Resources.Commissions,
      title: 'app.navMenu.finance.commissions',
      counter: 'commissions/count',
    },
    {
      resource: Resources.RequestBankOperations,
      title: 'app.navMenu.finance.bankOperations',
      counter: 'bank_operations/count',
    },
    {
      resource: Resources.BankOperations,
      title: 'app.navMenu.finance.bankOperationsFinalStatuses',
    },
    {
      resource: Resources.WorkTeams,
      title: 'app.navMenu.finance.workTeams',
    },
    {
      resource: Resources.ProviderAccounts,
      title: 'app.navMenu.finance.providerAccounts',
    },
    {
      resource: Resources.CommissionRecalculationTasks,
      title: 'app.navMenu.finance.commissionRecalculationTasks',
    },
    {
      resource: Resources.Reconciliation,
      title: 'app.navMenu.finance.reconciliation',
    },
  ],
};

const USERS: MultiLevelMenuItem = {
  title: 'app.navMenu.users.title',
  icon: <Person />,
  items: [
    {
      resource: Resources.Users,
      title: 'app.navMenu.users.users',
    },
    {
      resource: Resources.Roles,
      title: 'app.navMenu.users.roles',
    },
    {
      resource: Resources.UserActions,
      title: 'app.navMenu.users.userActions',
    },
  ],
};

const DIRECTORIES: MultiLevelMenuItem = {
  title: 'app.navMenu.directories.title',
  icon: <ImportContacts />,
  items: [
    {
      resource: Resources.Companies,
      title: 'app.navMenu.directories.companies',
    },
    {
      resource: Resources.Referrals,
      title: 'app.navMenu.directories.referrals',
    },
  ],
};

const API_CLIENTS: MenuItem = {
  title: 'app.navMenu.apiClients.title',
  icon: <Security />,
  resource: Resources.ApiClients,
};

const MERCHANTS: MenuItem = {
  title: 'app.navMenu.merchants.title',
  icon: <AccountBox />,
  resource: Resources.Merchants,
};

const DASHBOARD: MenuItem = {
  title: 'app.navMenu.dashboard.title',
  icon: <Dashboard />,
  resource: Resources.Dashboard,
};

const MONITORING: MultiLevelMenuItem = {
  title: 'app.navMenu.monitoring.title',
  icon: <MonitorHeartIcon />,
  items: [
    {
      resource: Resources.OrderConversion,
      title: 'app.navMenu.monitoring.orderConversion',
    },
    {
      resource: Resources.OrderConversionChart,
      title: 'app.navMenu.monitoring.orderConversionChart',
    },
    {
      resource: Resources.OrderProviderExternalErrors,
      title: 'app.navMenu.monitoring.orderProviderExternalErrors',
    },
    {
      resource: Resources.MonitoringSettings,
      title: 'app.navMenu.monitoring.monitoringSettings',
    },
  ],
};

const GATEWAY_RULES: MultiLevelMenuItem = {
  title: 'app.navMenu.gatewayRules.title',
  icon: <Rule />,
  items: [
    {
      resource: Resources.GatewayRules,
      title: 'app.navMenu.gatewayRules.gatewayRules',
    },
    {
      resource: Resources.OrderMethods,
      title: 'app.navMenu.gatewayRules.orderMethods',
    },
  ],
};

const ORDERS: MultiLevelMenuItem = {
  title: 'app.navMenu.orders.title',
  icon: <ShoppingCart />,
  items: [
    {
      resource: Resources.Orders,
      title: 'app.navMenu.orders.orders',
    },
    {
      resource: Resources.OrderAdjustments,
      title: 'app.navMenu.orders.orderAdjustments',
    },
    {
      resource: Resources.OrderManualCreate,
      title: 'app.navMenu.orders.orderManualCreate',
    },
    {
      resource: Resources.OrderAdjustmentsReport,
      title: 'app.navMenu.orders.orderAdjustmentsReport',
    },
    {
      resource: Resources.OrdersBulkUpdate,
      title: 'app.navMenu.orders.bulkUpdate',
    },
  ],
};

const METHODS: MultiLevelMenuItem = {
  title: 'app.navMenu.methods.title',
  icon: <CreditCard />,
  items: [
    {
      resource: Resources.Methods,
      title: 'app.navMenu.methods.methods',
    },
    {
      resource: Resources.MethodLogos,
      title: 'app.navMenu.methods.methodLogos',
    },
  ],
};

const GATEWAYS: MenuItem = {
  title: 'app.navMenu.gateways.title',
  icon: <Power />,
  resource: Resources.Gateways,
};

const PRESETS: MenuItem = {
  title: 'app.navMenu.presets.title',
  icon: <DisplaySettingsIcon />,
  resource: Resources.Presets,
};

const PROVIDERS: MenuItem = {
  title: 'app.navMenu.providers.title',
  icon: <ForkRight />,
  resource: Resources.Providers,
};

export const MENU_LIST: MenuList = [
  FINANCE,
  USERS,
  DIRECTORIES,
  API_CLIENTS,
  MERCHANTS,
  DASHBOARD,
  MONITORING,
  GATEWAY_RULES,
  ORDERS,
  METHODS,
  GATEWAYS,
  PRESETS,
  PROVIDERS,
];
